module.exports = __webpack_public_path__ + "media/navi/populife_lock-4d1bf07d.png";